import { Box } from '@mui/material';

import useQuery from '../../../utils/useQuery';

import BackSlider from './BackSlider';
import RightCornerTag from './RightCornerTag';
import AvatarInfo from './AvatarInfo';

const DetailsSection = ({
  username,
  userImage,
  userId,
  xpTitle,
  currentLeague,
  displayTrophyCount,
  details,
  achievements,
  gymInfo,
  isPublicProfile,
  inviteState,
  breadcrumbs,
}) => {
  const queryParameters = useQuery();
  const version = queryParameters.get('version');

  return (
    <Box
      bgcolor='#141516'
      sx={{
        position: 'relative',
        minHeight: { xs: 542, lg: 707 },
      }}
    >
      <BackSlider isWebviewVersion={version === 'webview'} />
      {version !== 'webview' && <RightCornerTag />}
      <AvatarInfo
        data={{ username, userImage, userId, xpTitle, currentLeague, displayTrophyCount, details }}
        gymInfo={gymInfo}
        isPublicProfile={isPublicProfile}
        inviteState={inviteState}
        breadcrumbs={breadcrumbs}
      />
    </Box>
  );
};

export default DetailsSection;
